import { Highway } from './Highway';
import { PAGES } from './pages';

/**
 * Wrapper that fans out the five top-level pages as five highways
 * radiating from the central hub. Order is preserved from `pages.ts`
 * so each highway carries the right yaw / colour / label.
 */
export function Highways() {
  return (
    <group>
      {PAGES.map((page) => (
        <Highway key={page.id} meta={page} />
      ))}
    </group>
  );
}
